var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 980 800",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M344.418 285.886C106.877 178.128 32.4748 73.9601 -0.000103377 -3.21521e-05V800H980C898.812 540.237 650.611 424.787 344.418 285.886Z",
    fill: "#3CC3E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundFlow);
export default __webpack_public_path__ + "static/media/background-flow.f351cac84ff8fe6daea8d0f6f6a11c43.svg";
export { ForwardRef as ReactComponent };